<template>
  <el-card class="user-content-panel">
    <div slot="header">
      <span class="panel-header">我的常用物料</span>
    </div>
    <div class="favourite-list">
      <SearchRow @handleFilter="handleFilter" />

      <div v-loading="listLoading">
        <div class="item-list" v-if="favoriteItemList.length">
          <div class="item-card" v-for="item in favoriteItemList" :key="item.itemId">
            <el-card shadow="hover" class="cursor" @click.native="itemDetail(item.itemId)">
              <div class="item-img">
                <img :src="getImageUrl(item)" />
              </div>
              <div class="item-info">
                <div class="item-price">￥{{ getPrice(item.pocmDTO) }}</div>
                <div class="item-name">{{ item.pocmDTO.itemName }}</div>
                <div class="item-time" v-if="item.pocmDTO.contractEnd">合同到期时间{{ item.pocmDTO.contractEnd | parseTime('{y}-{m}-{d}') }}</div>
              </div>
              <div class="item-num">
                <div>
                  <span style="padding-right: 10px">起订:{{ item.pocmDTO.factoryMOQ | thousandSymbol}}</span>
                  <span>起运:{{ item.pocmDTO.factoryMQ | thousandSymbol}}</span>
                </div>
                <!-- <div>DAG:进行中</div> -->
              </div>
            </el-card>
          </div>
        </div>
        <div class="pag-row" v-if="favoriteItemList.length">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="queryParam.page"
            :page-size="queryParam.pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
        <div v-else class="no-data">暂无数据</div>
      </div>
    </div>
  </el-card>
</template>

<script>
import SearchRow from './components/search-row'
import itemApi from '@/api/item'
import { commonUtils } from '@/utils/common'
export default {
  name: 'item-list',
  props: {
    quickOrder: {
      type: Boolean,
      default: true
    },
    orderLess: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      default: 'menu'
    }
  },
  components: {
    SearchRow
  },
  data () {
    return {
      queryParam: {
        page: 1,
        pageSize: 6,
        isStandard: '',
        isPrints: '',
        isMenu: '',
        isNonMenu: '',
        isCampaign: '',
        abiBrandId: '',
        channel: '',
        categoryId: '',
        keyword: '',
        minPrice: '',
        maxPrice: '',
        produceSupplierId: '',
        entityId: ''
      },
      total: null,
      favoriteItemList: [],
      listLoading: false
    }
  },
  created () {
    this.queryFavItemList()
  },
  methods: {
    // 获取商品列表
    queryFavItemList () {
      this.listLoading = true
      // switch (this.itemType) {
      //   case 'menu':
      //     this.queryParam.isMenu = '1'
      //     break
      //   case 'printing':
      //     this.queryParam.isPrints = '1'
      //     break
      //   case 'nonMenu':
      //     this.queryParam.isNonMenu = '1'
      //     break
      //   default:
      //     break
      // }
      itemApi.queryFavItemList(this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.favoriteItemList = res.data.resultData.favoriteItemList || []
          this.total = res.data.resultData.pageInfo.totalCounts
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryFavItemList()
    },
    // 搜索
    handleFilter (value) {
      this.queryParam.abiBrandId = value.abiBrandId
      this.queryParam.channel = value.channel
      this.queryParam.categoryId = value.categoryId
      this.queryParam.keyword = value.keyword
      this.queryParam.minPrice = value.minPrice
      this.queryParam.maxPrice = value.maxPrice
      this.queryParam.produceSupplierId = value.produceSupplierId
      this.queryFavItemList()
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.pocmDTO.imageList && item.pocmDTO.imageList.length > 0) {
        imageUri = item.pocmDTO.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      return (item.taxExcludedPrice).toFixed(2)
    },

    // 商品详情
    itemDetail (id) {
      this.$router.push({ path: `/material/item-detail/${id}` })
    },
    // 快速下单
    toFavourite () {
      this.$emit('toFavourite')
    },
    // 订单模版文件
    toTemplate () {
      this.$emit('toTemplate')
    },
    // 小于五万订单
    toOrderLess () {
      this.$router.push({ name: '' })
    }
  }
}
</script>

<style lang="scss" scoped>
.favourite-list {
  padding: 30px 20px;
  .item-list {
    width: 100%;
    .item-card {
      width: 33%;
      display: inline-block;
      padding: 10px;
      box-sizing: border-box;
      .el-card {
        width: 100%;
        height: 350px;
        .item-img {
          width: 100%;
          height: 170px;
          text-align: center;
          box-sizing: border-box;
          padding-top: 5px;
          img {
            height: 100%;
            max-width: 100%;
          }
        }
        .item-info {
          height: 130px;
          text-align: center;
          border-bottom: 1px solid #ddd;
          .item-price {
            color: $base-red;
            font-size: 28px;
            font-weight: bold;
            padding-top: $content-middle;
          }
          .item-name {
            color: #000;
            font-size: 18px;
            font-weight: bold;
            padding: 15px 0 10px 0;
          }
          .item-name:hover {
            color: $base-red;
          }
          .item-desc {
            color: #666;
            font-size: $font-14;
          }
        }
        .item-num {
          height: 50px;
          color: #666;
          display: flex;
          font-size: $font-12;
          align-items: center;
          justify-content: space-between;
          padding: 0 $content-middle;
        }
      }
    }
  }
}
</style>
